import axios from 'axios';
// const base_url = `${process.env.REACT_APP_API_ENDPOINT}`;
import { base_url, app_back_end_url_token } from "../AppConfig";


async function getToken(code) {
    const response = await axios.post(`${app_back_end_url_token}`, { code });
    const result = response.data;
    return result;
}

async function checkToken() {
    const response = await axios.get(`${base_url}/primeapi/v2/user`);
    const result = response.data;
    return result;
}

async function getEnrollments(limit = 10, cursor) {
    let url = `${base_url}/primeapi/v2/enrollments?page[limit]=${limit}&include=learningObject&filter.loTypes=course&sort=dateEnrolled`;
    if (cursor) {
        url = url + `&page[cursor]=${cursor}`;
    }
    const response = await axios.get(url);
    return response.data;
}

async function getLearningObjects(limit = 10, cursor, sort = "name", filter) {
    let url = `${base_url}/primeapi/v2/learningObjects?page[limit]=${limit}&filter.loTypes=course&filter.ignoreEnhancedLP=true`;
    if (cursor) {
        url = url + `&page[cursor]=${cursor}`;
    }
    if (sort) {
        url = url + `&sort=${sort}`;
    }
    if (filter) {
        url = url + `&filter.loFormat=${filter}`;
    }
    const response = await axios.get(url);
    return response.data;
}

async function getLearningObject(loId) {
    const response = await axios.get(`${base_url}/primeapi/v2/learningObjects/${loId}?include=enrollment.loResourceGrades%2Cinstances.loResources.resources`);
    const result = response.data;
    return result;
}


async function getCatalogs(offset = 0, limit = 10) {
    const response = await axios.get(`${base_url}/primeapi/v2/catalogs?page[offset]=${offset}&page[limit]=${limit}&sort=name`);
    const result = response.data;
    return result;
}

async function setEnrollment(loId, loInstanceId) {
    const response = await axios.post(`${base_url}/primeapi/v2/enrollments?loId=${loId}&loInstanceId=${loInstanceId}`);
    const result = response.data;
    return result;
}
async function getRecommendations(offset = 0, limit = 10) {
    const response = await axios.get(`${base_url}/primeapi/v2/recommendations?include=learningObject&page[offset]=${offset}&page[limit]=${limit}&filter.recType=standard&filter.loTypes=course`);
    const result = response.data;
    return result;
}
async function getUser() {
    const response = await axios.get(`${base_url}/primeapi/v2/user`);
    const result = response.data;
    return result;
}

async function getAccount() {
    const response = await axios.get(`${base_url}/primeapi/v2/account`);
    return response.data;
}

async function getUserSkills(userId, offset = 0, limit = 10) {
    const response = await axios.get(`${base_url}/primeapi/v2/users/15199635/userSkills?include=skill&page[offset]=0&page[limit]=10&sort=dateAchieved`);
    const result = response.data;
    return result;
}

async function getUserSkillInterests(userId, offset = 0, limit = 10) {
    const response = await axios.get(`${base_url}/primeapi/v2/users/${userId}/skillInterests?include=skill&page[offset]=0&page[limit]=10&sort=dateCreated&filter.skillInterestTypes=ADMIN_DEFINED`);
    const result = response.data;
    return result;
}

async function getUserNotifications(userId, limit = 10) {
    const response = await axios.get(`${base_url}/primeapi/v2/users/${userId}/userNotifications?page[limit]=${limit}&announcementsOnly=false&language=en_US`);
    const result = response.data;
    return result;
}

async function patchUserNotifications(userId, body) {
    body.attributes.actionTaken = true;
    body.attributes.read = true;
    const response = await axios.patch(`${base_url}/primeapi/v2/users/${userId}/userNotifications/${body.id}`,
        {
            "data": body
        },
        {
            headers: {
                'Content-Type': 'application/vnd.api+json;charset=UTF-8'
            }
        }
    );
}

//Get a list of all the skills for an account in your organization. It includes the skill name and description of each skill
async function getSkills(limit = 10, offset = 0) {
    const response = await axios.get(`${base_url}/primeapi/v2/skills?page[offset]=${offset}&page[limit]=${limit}&sort=name`);
    const result = response.data;
    return result;
}

async function getBadges(userId, limit = 10) {
    const response = await axios.get(`${base_url}/primeapi/v2/users/${userId}/userBadges?include=badge&page[offset]=0&page[limit]=10&sort=dateAchieved`);
    const result = response.data;
    return result;
}


export const apis = {
    getToken,
    checkToken,
    getEnrollments,
    getLearningObjects,
    getLearningObject,
    getCatalogs,
    setEnrollment,
    getRecommendations,
    getUser,
    getAccount,
    getUserSkills,
    getUserSkillInterests,
    getUserNotifications,
    patchUserNotifications,
    getSkills,
    getBadges
};





